import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import "./TaskListView.css";
import axios from "axios";
import Swal from "sweetalert2";
import Topbar from "../Topbar/Topbar";
import { useSelector } from "react-redux";

export default function TaskListView() {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
      const permissions = useSelector((state) => state.permissions); // Adjust based on your reducer path

  const [data, setData] = useState([]);
  const [customerdelete, setCustomerdelete] = useState(false);
  const [filters, setFilters] = useState({
    taskAssignDate: "",
    taskStatus: "",
    approveStatus: "",
    taskName: "",
    taskType: "",
    taskPriority: "",
    deadline: "",
    assignedBy: "",
    completedPerson: "",
    approvedPerson: "",
    description: "",
    taskDenied: "",
    deniedReason: "",
  });

  const [taskCounts, setTaskCounts] = useState({});

  const [columnVisibility, setColumnVisibility] = useState({
    taskAssignDate: true,
    taskStatus: true,
    approveStatus: true,
    taskName: true,
    taskType: true,
    taskPriority: true,
    deadline: true,
    assignedBy: true,
    completedPerson: true,
    approvedPerson: true,
    description: true,
    taskDenied: true,
    deniedReason: true,

  });

  // const data, setdata] = useState([]);

useEffect(() => {
  axios
    .post(apiUrl + "getdata-enquirytask")
    .then((res) => {
      console.log("Task Data:", res.data);
      const fetchedData = res.data.message;

          const sortedData = [...fetchedData].reverse();

    console.log("Sorted data:", sortedData);
      setData(sortedData);
       

    
    })
    .catch((err) => {
      console.log("Error Fetching Tasks", err);
    });
}, []);


 


  //Staff Data
  const [staffData, setstaffData] = useState([]);
  useEffect(() => {
    axios
      .post(
        apiUrl + "viewstaff",

        {}
      )
      .then((res) => {
        setstaffData(res.data.message);

        console.log(res.data.message);
      });
  }, []);

  const handleDelete = async (customerid) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axios.post(apiUrl+"delete", {
          customerid: customerid,
        });
        Swal.fire("Deleted!", "Your data has been deleted.", "success");
        setCustomerdelete(true);
      } catch (error) {
        Swal.fire("Error!", "Something went wrong while deleting.", "error");
        console.error("Delete Error:", error);
      }
    }
  };

  const navi = useNavigate();

  const [setting, setSetting] = useState(false);

  const settingPopup = (e) => {
    e.preventDefault();
    setSetting(!setting);
  };

  const handleColumnVisibilityChange = (e) => {
    const { name, checked } = e.target;
    setColumnVisibility((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const filteredData = data.filter((customer) => {
    return Object.keys(filters).every((key) => {
      if (!filters[key]) return true;
      return String(customer[key]).toLowerCase().includes(filters[key]);
    });
  });
  console.log("Filtered Data:", filteredData); // Debugging log


  const getCompletedPerson = (status) => {
    if (!status) return "";
    switch (status.toLowerCase().trim()) {
      case "saravanan":
        return "devide-saravanan";
      case "arun":
        return "devide-arun";
      case "ravikumar":
        return "devide-ravikumar";
      case "santhosh":
        return "devide-santhosh";
    }
  };

  const getApprovedPerson = (status) => {
    if (!status) return "";
    switch (status.toLowerCase().trim()) {
      case "saravanan":
        return "devide-saravanan";
      case "arun":
        return "devide-arun";
      case "ravikumar":
        return "devide-ravikumar";
      case "santhosh":
        return "devide-santhosh";
    }
  };
  const getTaskStatus = (status) => {
    if (!status) return "";
    switch (status.toLowerCase().trim()) {
      case "open":
        return "status-open";
      case "progress":
        return "status-progress";
      case "completed":
        return "status-completed";
      case "cancelled":
        return "status-cancelled";
          case "hold":
        return "status-hold";
      default:
        return "";
    }
  };
  const getApproveStatus = (status) => {
    if (!status) return "";
    switch (status.toLowerCase().trim()) {
      case "open":
        return "device-open";
      case "progress":
        return "device-progress";
      case "completed":
        return "device-completed";
      case "cancelled":
        return "device-cancelled";
      default:
        return "";
    }
  };


  const gotorecoringtask =(e)=>
  {
    navi('/recurring')
  }
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value.toLowerCase(), // Normalize input for case-insensitive search
    }));
  };

  useEffect(() => {
    axios
      .get(apiUrl+"task-status")
      .then((res) => setTaskCounts(res.data))
      .catch((err) => console.error("Task status error:", err));
  }, [apiUrl]);
function formatDate(dateString) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${day}-${month}-${year} / ${hours}:${minutes} ${ampm}`;
  }
  return (
    <div className="customer-scroll-stop">
      <Topbar />
      <Container fluid className="pt-1 customer-row">
        <h3 className="px-2">My Task</h3>

        {/* <Row className="task-row-width">
          <Col className="dashborder_task mt-4 mb-5">
            <Row className="red-card">
              <p className="text-center box-txt " style={{ marginTop: "12px" }}>
                Over Due
              </p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1">{data.length}</h5>
            </Row>
          </Col>
          <Col className="dashborder_task mt-4 mb-5">
            <Row className="yellow-card">
              <p className="text-center pt-1 box-txt">Open</p>
            </Row>
            <Row className="number">
              <h5 className="text-center">{statusCounts.open}</h5>
            </Row>
          </Col>
          <Col className="dashborder_task mt-4 mb-5">
            <Row className="grey-card ">
              <p className="text-center pt-1 box-txt text-white">Progress</p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1">{statusCounts.progress}</h5>
            </Row>
          </Col>
          <Col className="dashborder_task mt-4 mb-5">
            <Row className="green-card row-margin">
              <p className="text-center pt-1 box-txt">Completed</p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1">{statusCounts.completed}</h5>
            </Row>
          </Col>
          <Col className="dashborder_task mt-4 mb-5">
            <Row className="brown-card">
              <p className="text-center pt-1 box-txt">Upcomming</p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1">{statusCounts.offline}0</h5>
            </Row>
          </Col>
        </Row> */}

{permissions?.Task?.["Task Statistics"]?.Read && (
        <Row className=" row-width">
                  <Col className="dashborder mt-4   mb-5 mx-2 ">
                    <Row className="red-card">
                      <p className="text-center box-txt " style={{ marginTop: "8px" }}>
                        Over Due
                      </p>
                    </Row>
                    <Row className="number">
                      <h5 className="text-center pt-1">{taskCounts["OverDue"] ?? 0}</h5>
                    </Row>
                  </Col>
                  <Col className="dashborder mt-4 mb-5 mx-1  ">
                    <Row className="yellow-card">
                      <p className="text-center  box-txt">Open</p>
                    </Row>
                    <Row className="number">
                      <h5 className="text-center pt-1">{taskCounts["Open"] ?? 0}</h5>
                    </Row>
                  </Col>
                  <Col className="dashborder mt-4 mb-5  mx-1">
                    <Row className="grey-card ">
                      <p className="text-center pt-1 box-txt">Progress</p>
                    </Row>
                    <Row className="number">
                      <h5 className="text-center pt-1">{taskCounts["Progress"] ?? 0}</h5>
                    </Row>
                  </Col>
                  <Col className="dashborder mt-4 mb-5 mx-1">
                    <Row className="green-card row-margin">
                      <p className="text-center pt-1 box-txt">Completed</p>
                    </Row>
                    <Row className="number">
                      <h5 className="text-center pt-1">{taskCounts["Completed"] ?? 0}</h5>
                    </Row>
                  </Col>
                  <Col className="dashborder mt-4 mb-5 mx-1">
                    <Row className="brown-card">
                      <p className="text-center pt-1 box-txt">Upcomming</p>
                    </Row>
                    <Row className="number">
                      <h5 className="text-center pt-1">{taskCounts["Upcoming"] ?? 0}</h5>
                    </Row>
                  </Col>
                 
                </Row>
)}

        <Row className="button-bottom-task" xs={1} sm={2}>
          <Col className="mt-2 mb-2">
            &ensp;
            <button
              onClick={() => window.location.reload()}
              className="black-btn black-btn1"
            >
              Refresh
            </button>
            <button
              className="black-btn black-btn1 ms-4"
              onClick={gotorecoringtask}
            >
              Operations
            </button>
          </Col>

          
          <Col className="mt-2 text-end">
            {/* <button className="black-btn black-btn1 btnadd">Export</button> */}
            &emsp;&emsp;
            <button onClick={settingPopup} className="black-btn black-btn1">
              Settings
            </button>
            {setting && (
              <div className="setting-popup-overlay">
                <div className="setting-popup-container">
                  <button className="setting-close-btn" onClick={settingPopup}>
                    &times;
                  </button>
                  <div className="setting-popup-content">
                    <div className="setting-checkbox-row">
                      <label>
                        <input
                          type="checkbox"
                          checked={Object.values(columnVisibility).every(
                            (v) => v
                          )}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            setColumnVisibility(
                              Object.keys(columnVisibility).reduce(
                                (acc, key) => {
                                  acc[key] = isChecked;
                                  return acc;
                                },
                                {}
                              )
                            );
                          }}
                        />

                        <span
                          className="checkbox-down"
                          style={{ fontSize: "17" }}
                        >
                          Select All
                        </span>
                      </label>
                    </div>
                    <div className="setting-checkbox-grid">
                      {Object.keys(columnVisibility).map((key) => (
                        <label key={key} className="label-setting-popup">
                          <input
                            type="checkbox"
                            name={key}
                            checked={columnVisibility[key]}
                            onChange={handleColumnVisibilityChange}
                            className="checbox-popup"
                          />
                          <span className="checkbox-down1">
                            {key
                              .replace(/([a-z])([A-Z])/g, "$1 $2")
                              .replace(/_/g, " ")
                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                          </span>
                        </label>
                      ))}
                    </div>

                    <button
                      className="setting-submit-btn"
                      onClick={settingPopup}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </Col>
        </Row>

        <br />

        {permissions?.Task?.["Task Module"]?.Read && (

        <div className="scrolltable">
          <table className="table table-bordered">
            <thead className="table-th text-center">
              <tr>
                {columnVisibility.taskAssignDate && (
                  <th className="table-th-content">Task Assign Date</th>
                )}
                {columnVisibility.taskStatus && (
                  <th className="table-th-content">Task Status</th>
                )}
                {columnVisibility.approveStatus && (
                  <th className="table-th-content">Approve Status</th>
                )}
                {columnVisibility.taskName && (
                  <th className="table-th-content">Task Name</th>
                )}
                {columnVisibility.taskType && (
                  <th className="table-th-content">Task Type</th>
                )}
                {columnVisibility.taskPriority && (
                  <th className="table-th-content">Task Priority</th>
                )}
                {columnVisibility.deadline && (
                  <th className="table-th-content">Deadline</th>
                )}
                {columnVisibility.assignedBy && (
                  <th className="table-th-content">Assigned By</th>
                )}
                {columnVisibility.completedPerson && (
                  <th className="table-th-content">Completed Person</th>
                )}
                {columnVisibility.approvedPerson && (
                  <th className="table-th-content">Approved Person</th>
                )}
                {columnVisibility.description && (
                  <th className="table-th-content">Description</th>
                )}
                {columnVisibility.taskDenied && (
                  <th className="table-th-content">Task Denied</th>
                )}
                {columnVisibility.deniedReason && (
                  <th className="table-th-content">Denied Reason</th>
                )}

                {columnVisibility.delete && (
                  <th className="table-th-content">Delete</th>
                )}
              </tr>
            </thead>

            <tbody className="tr:nth-child(even)">
              <tr>
                {columnVisibility.taskAssignDate && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="taskAssignDate"
                      onChange={handleFilterChange}
                      placeholder="Search"
                      type="date"
                    />
                  </td>
                )}
                {columnVisibility.taskStatus && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="taskStatus"
                      placeholder="Search"
                      onChange={handleFilterChange}
                    >
                      <option>Select</option>
                      <option value="Open">Open</option>
                      <option value="Progress">Progress</option>
                      <option value="Cancelled">Cancelled</option>
                      <option value="Completed">Completed</option>
                    </select>
                  </td>
                )}
                {columnVisibility.approveStatus && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="approveStatus"
                      placeholder="Search"
                      onChange={handleFilterChange}
                    >
                      <option>Select</option>
                      <option value="Open">Open</option>
                      <option value="Progress">Progress</option>
                      <option value="Cancelled">Cancelled</option>
                      <option value="Completed">Completed</option>
                    </select>
                  </td>
                )}
                {columnVisibility.taskName && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="taskName"
                      onChange={handleFilterChange}
                      placeholder="Search"
                      type="text"
                    />
                  </td>
                )}
                {columnVisibility.taskType && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="taskType"
                      onChange={handleFilterChange}
                      placeholder="Search"
                      type="text"
                    />
                  </td>
                )}
                {columnVisibility.taskPriority && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="taskPriority"
                      placeholder="Search"
                      onChange={handleFilterChange}
                    >
                      <option>Select</option>
                      <option value="Low">Low</option>
                      <option value="High">High</option>
                    </select>
                  </td>
                )}

                {columnVisibility.deadline && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="taskAssignDate"
                      onChange={handleFilterChange}
                      placeholder="Search"
                      type="date"
                    />
                  </td>
                )}
                {columnVisibility.assignedBy && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="assignedBy"
                      placeholder="Search"
                      onChange={handleFilterChange}
                    >
                      <option value="">Select</option>
                      {staffData.map((staff) => (
                        <option key={staff.staffId} value={staff?.staffName}>
                          {staff?.staffName}
                        </option>
                      ))}
                    </select>
                  </td>
                )}
                {columnVisibility.completedPerson && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="completedPerson"
                      placeholder="Search"
                      onChange={handleFilterChange}
                    >
                      <option value="">Select</option>
                      {staffData.map((staff) => (
                        <option key={staff.staffId} value={staff?.staffName}>
                          {staff?.staffName}
                        </option>
                      ))}
                    </select>
                  </td>
                )}
                {columnVisibility.approvedPerson && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="approvedPerson"
                      placeholder="Search"
                      onChange={handleFilterChange}
                    >
                      <option value="">Select</option>
                      {staffData.map((staff) => (
                        <option key={staff.staffId} value={staff?.staffName}>
                          {staff?.staffName}
                        </option>
                      ))}
                    </select>
                  </td>
                )}
                {columnVisibility.description && (
                  <td>
                    <input
                      className="table-search table-search-date background-change"
                      type="text"
                      name="description"
                      onChange={handleFilterChange}
                      placeholder="Search"
                    />
                  </td>
                )}
                {columnVisibility.taskDenied && (
                  <td>
                    <input
                      className="table-search table-search-date background-change"
                      type="text"
                      name="taskDenied"
                      onChange={handleFilterChange}
                      placeholder="Search"
                    />
                  </td>
                )}
                {columnVisibility.deniedReason && (
                  <td>
                    <input
                      className="table-search-date table-search background-change"
                      type="text"
                      name="deniedReason"
                      onChange={handleFilterChange}
                      placeholder="Search"
                    />
                  </td>
                )}
              </tr>

              {filteredData.map((d, i) => (
                <tr key={i}>
                  {columnVisibility.taskAssignDate && (
                    <td>{formatDate(d.assignDateTime)}</td>
                  )}
                  {columnVisibility.taskStatus && (
                    <td>
                      <span className={getTaskStatus(d.taskStatus)}>
                        {d.taskStatus}
                      </span>
                    </td>
                  )}
                  {columnVisibility.approveStatus && (
                    <td>
                      <span className={getApproveStatus(d.approveStatus)}>
                        {d.approveStatus}
                      </span>
                    </td>
                  )}

                  {columnVisibility.taskName && <td>{d.taskName}</td>}
                  {columnVisibility.taskType && <td>{d.taskType}</td>}
                  {columnVisibility.taskPriority && <td>{d.taskPriority}</td>}

                  {columnVisibility.deadline && <td>{d.deadline}</td>}
                  {columnVisibility.assignedBy && <td>{d.assignedBy?.staffName}</td>}

                  {columnVisibility.completedPerson &&  <td>
    {d.assignedTo.map((person) => person?.staffName).join(", ")}
  </td>}
                 

                  {columnVisibility.approvedPerson && (
                    <td>
                      <span className={getApprovedPerson(d.approvedPerson)}>
                      {d.approvePerson.map((person) => person?.staffName).join(", ")}
                      </span>
                    </td>
                  )}
                  {columnVisibility.description && <td>{d.description}</td>}
                  {columnVisibility.taskDenied && <td>{Array.isArray(d.taskDenied) ? d.taskDenied.map(denial => denial.taskDeniedBy).filter(Boolean).join(", ") : d.taskDenied?.taskDeniedBy || ""}</td>}
                  {columnVisibility.deniedReason && <td>{Array.isArray(d.taskDenied) ? d.taskDenied.map(denial => denial.taskDeniedReason).filter(Boolean).join(", ") : d.taskDenied?.taskDeniedReason || ""}</td>}

                  {/* {columnVisibility.delete && (
                    <td>
                      <button
                        onClick={() => handleDelete(d.customerid)}
                        style={{ backgroundColor: "none" }}
                        className="deletebtn text-center"
                      >
                        <MdDelete size={20} />
                      </button>
                    </td>
                  )} */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        )}
      </Container>
    </div>
  );
}
